import S from 'common/service/sanctuary';

import {
  EMPTY,
  NOT_EMPTY,
  EQUALS,
  NOT_EQUALS,
  LESS_THAN,
  GREATER_THAN,
  BETWEEN,
  WITHIN,
} from './operators';

export const getConstraintValue = constraint => S.pipe([
  S.get(S.is(String), 'operator'),
  S.chain((operator = EQUALS) => ({
    [EMPTY]: S.Just(null),
    [NOT_EMPTY]: S.Just(null),
    [EQUALS]: S.toMaybe(constraint.value),
    [NOT_EQUALS]: S.toMaybe(constraint.value),
    [LESS_THAN]: S.toMaybe(constraint.value),
    [GREATER_THAN]: S.toMaybe(constraint.value),
    [BETWEEN]: S.toMaybe(constraint.value),
    [WITHIN]: S.toMaybe(constraint.value),
  })[operator] || S.Nothing),
])(constraint);

export default {};
